import styled from "styled-components";
const MobileBreakPoints = ["base", "mobile"];

export const FilterFieldset = styled.div<{
  addPaddingTop?: boolean;
  grid?: boolean;
}>`
  display: ${({ grid }) => (grid ? "grid" : "inline-flex")};
  grid-template-columns: auto 1fr;
  flex-wrap: wrap;
  border-bottom: 1px solid #000;
  width: 100%;
  align-items: center;

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
          column-gap: ${props.theme.spacePx(breakpoint, 9)};
          row-gap: ${props.theme.spacePx(breakpoint, 9)};
          padding-bottom:${props.theme.spacePx(breakpoint, 9)};
          padding-top:${
            props.addPaddingTop ? props.theme.spacePx(breakpoint, 9) : "0"
          };
        `;
    })}
`;

export const FilterLegend = styled.div`
  white-space: nowrap;
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        height: ${props.theme.spacePx(
          breakpoint,
          MobileBreakPoints.includes(breakpoint) ? 6 : 7
        )};
        ${props.theme.textStyle(breakpoint, `h4Heading`)};
        line-height: ${props.theme.spacePx(
          breakpoint,
          MobileBreakPoints.includes(breakpoint) ? 6 : 7
        )};
        padding 0;
        /*
         border: 1px solid #000;
          padding: 0 ${props.theme.spacePx(breakpoint, 10)};
          background-color: #ff0;
        */        
      `;
    })}
`;
